import { Component, OnInit } from '@angular/core';
import { JsonService } from '../../_services/json.service';
import { LoggerService } from '../../_services/logger.service';

@Component({
  selector: 'app-list-counter',
  templateUrl: './list-counter.component.html',
  styleUrls: ['./list-counter.component.scss']
})
export class ListCounterComponent implements OnInit {

  public prescriptionUnprocessedCount: number = 0;
  public prescriptionIntegratedCount: number = 0;
  public prescriptionReviewedCount: number = 0;
  public prescriptionReviewedTodayCount: number = 0;
  public prescriptionReviewedGroupCount: number = 0;
  
  constructor(
    private jsonService: JsonService,
    private logger: LoggerService
  ) { }

  ngOnInit(): void {
    this.getPrescriptionIntegratedCount();
    this.getPrescriptionUnprocessedCount();
    this.getPrescriptionReviewedCount();
    this.getPrescriptionReviewedTodayCount();
    this.getPrescriptionReviewedGroupCount();
  }

  public getPrescriptionIntegratedCount(){
    this.jsonService.getPrescriptionIntegratedCount().subscribe(
      resp => {
        this.prescriptionIntegratedCount = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar contagem de prescrições integradas', erro);
      }
    );
  }

  public getPrescriptionUnprocessedCount(){
    this.jsonService.getPrescriptionUnprocessedCount().subscribe(
      resp => {
        this.prescriptionUnprocessedCount = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar contagem de prescrições não processadas', erro);
      }
    );
  }

  public getPrescriptionReviewedCount(){
    this.jsonService.getPrescriptionReviewedCount().subscribe(
      resp => {
        this.prescriptionReviewedCount = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar contagem de prescrições revisadas', erro);
      }
    );
  }

  public getPrescriptionReviewedTodayCount(){
    this.jsonService.getReviewedPrescripitionsTodayCount().subscribe(
      resp => {
        this.prescriptionReviewedTodayCount = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar contagem de prescrições revisadas hoje', erro);
      }
    );
  }

  public getPrescriptionReviewedGroupCount(){
    this.jsonService.getReviewedPrescripitionsGroupCount().subscribe(
      resp => {
        this.prescriptionReviewedGroupCount = resp;
      },
      erro => {
        this.logger.error('Erro ao carregar contagem de prescrições revisadas por grupo', erro);
      }
    );
  }
}
